import ModalComponent from '../components/ModalComponent';

interface Props {
  open: boolean
  handleClose: () => void
  handleSave: () => void
}

const Index = (props:Props) => {
  const { open, handleClose, handleSave } = props;

  return (
    <ModalComponent
      title="Logout confirmation"
      confirmButtonText="Logout"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <p className="mb-0">Are you sure you want to logout?</p>
    </ModalComponent>
  );
};

export default Index;
